import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { DigiConnectComponent } from './digi-connect/digi-connect.component';
import { DigiGameComponent } from './digi-game/digi-game.component';
import { DigiResultComponent } from './digi-result/digi-result.component';
import { CanActivateDigiGame } from './digi-game/can-activate.guard';

const routes: Routes = [
  { path: 'digi/connect', component: DigiConnectComponent},
  { path: 'digi/game', component: DigiGameComponent, canActivate: [CanActivateDigiGame]},
  { path: 'digi/result', component: DigiResultComponent}
];

export const ModuleRouting: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/digi/digi.routing.ts